/* BAG CRAP: free-shipping progress bar + "add one to ship free" suggestions in the side cart.
   Runs alongside cart.js without changing it: whenever cart.js rewrites the shipping message,
   this adds the bar back and refreshes the suggestions. */
(function () {
  var box = document.querySelector("#side-cart .shipping-threshold");
  var nudge = document.querySelector("#side-cart .ship-nudge");
  if (!box || !nudge) return;

  var currency = box.dataset.currency || "USD";
  var thresholdCents = Number(box.dataset.threshold) * 100;
  var collection = nudge.dataset.collection || "mini-bag-charms";
  var hardware = nudge.dataset.hardware || "clips-carabiners"; // one slot goes to a clip/chain from this collection
  var maxGapCents = Number(nudge.dataset.maxGap || 40) * 100; // suggest add-ons once the bag is within this of free shipping ($35+ bags at a $75 threshold)
  var labelUnder = nudge.dataset.labelUnder || "Add one to ship free"; // every item shown closes the gap on its own
  var labelUnderFew = nudge.dataset.labelUnderFew || "Add a few to ship free"; // at least one item shown doesn't
  var labelOver = nudge.dataset.labelOver || "Add a little extra"; // shown after free shipping is unlocked
  var exclude = (nudge.dataset.exclude || "").split(",").map(function (v) { return parseInt(v, 10); }).filter(Boolean);
  // Specific color options to offer from multi-option listings (product handle : variant id)
  var extras = (nudge.dataset.extras || "heart-shaped-carabiner-clips:46648114905275")
    .split(",").map(function (v) { var p = v.split(":"); return { handle: p[0], id: parseInt(p[1], 10) }; })
    .filter(function (e) { return e.handle && e.id; });
  // Always offered first: the size of this listing that best closes the gap
  var pinned = nudge.dataset.pinned || "mystery-blind-box-vintage-keychains";
  // Shown as a suggestion only when the order is this close (the $5 Bag Crap logo charm)
  var smallGap = { handle: nudge.dataset.smallGapItem || "bag-crap-signature-1-mini-tag-charm", maxCents: Number(nudge.dataset.smallGapMax || 5) * 100 };
  var maxItems = Number(nudge.dataset.maxItems || 6); // how many suggestions to show in the swipe row
  var hardwareSlots = Number(nudge.dataset.hardwareSlots || 2);
  var pools = {};

  function money(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  }
  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function sized(src) {
    return src ? src.replace(/(\.[a-z]+)(\?|$)/i, "_300x$1$2") : "";
  }

  function loadPool(handle) {
    if (!handle) return Promise.resolve([]);
    if (pools[handle]) return Promise.resolve(pools[handle]);
    return fetch("/collections/" + handle + "/products.json?limit=250")
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        pools[handle] = (data.products || [])
          .filter(function (p) { return p.variants.length === 1 && p.variants[0].available; })
          .map(function (p) {
            return {
              id: p.variants[0].id,
              title: p.title,
              handle: p.handle,
              price: Math.round(parseFloat(p.variants[0].price) * 100),
              image: p.images && p.images[0] ? p.images[0].src : ""
            };
          })
          .filter(function (p) { return p.price > 0 && p.price < 5000 && exclude.indexOf(p.id) === -1; });
        return pools[handle];
      })
      .catch(function () { pools[handle] = []; return pools[handle]; });
  }

  function loadExtras() {
    if (pools.__extras) return Promise.resolve(pools.__extras);
    return Promise.all(extras.map(function (e) {
      return fetch("/products/" + e.handle + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var v = p.variants.filter(function (x) { return x.id === e.id; })[0];
          if (!v || !v.available) return null;
          return {
            id: v.id,
            title: v.title,
            handle: p.handle + "?variant=" + v.id,
            price: v.price,
            image: (v.featured_image && v.featured_image.src) || p.featured_image || ""
          };
        })
        .catch(function () { return null; });
    })).then(function (list) {
      pools.__extras = list.filter(Boolean);
      return pools.__extras;
    });
  }

  function loadSmallGap() {
    if (pools.__small !== undefined) return Promise.resolve(pools.__small);
    return fetch("/products/" + smallGap.handle + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && p.variants[0];
        pools.__small = v && v.available ? {
          id: v.id,
          title: p.title,
          handle: p.handle,
          price: v.price,
          image: (v.featured_image && v.featured_image.src) || p.featured_image || ""
        } : null;
        return pools.__small;
      })
      .catch(function () { pools.__small = null; return null; });
  }

  function loadPinned() {
    if (!pinned) return Promise.resolve(null);
    if (pools.__pinned !== undefined) return Promise.resolve(pools.__pinned);
    return fetch("/products/" + pinned + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { pools.__pinned = p; return p; })
      .catch(function () { pools.__pinned = null; return null; });
  }

  // Cheapest size that closes the gap, otherwise the biggest size available
  function pinnedPick(p, remaining, inCart) {
    if (!p) return null;
    var ids = p.variants.map(function (v) { return v.id; });
    if (inCart.some(function (id) { return ids.indexOf(id) !== -1; })) return null;
    var avail = p.variants.filter(function (v) { return v.available; }).sort(function (a, b) { return a.price - b.price; });
    if (!avail.length) return null;
    var v = avail.filter(function (x) { return x.price >= remaining; })[0] || avail[avail.length - 1];
    var single = p.variants.length === 1;
    return {
      id: v.id,
      title: nudge.dataset.pinnedTitle || "Mystery Keychain Blind Box",
      note: single ? "" : v.title,
      handle: p.handle + "?variant=" + v.id,
      price: v.price,
      image: (v.featured_image && v.featured_image.src) || p.featured_image || ""
    };
  }

  function pick(list, remaining, inCart, count) {
    var options = list.filter(function (p) { return inCart.indexOf(p.id) === -1; });
    // Cheapest items that get the order over the line first, at most two per price point
    var closers = options.filter(function (p) { return p.price >= remaining; }).sort(function (a, b) { return a.price - b.price; });
    var nearest = options.filter(function (p) { return p.price < remaining; }).sort(function (a, b) { return b.price - a.price; });
    var picks = [], perPrice = {};
    closers.forEach(function (p) {
      if (picks.length >= count || (perPrice[p.price] || 0) >= 2) return;
      perPrice[p.price] = (perPrice[p.price] || 0) + 1;
      picks.push(p);
    });
    nearest.forEach(function (p) { if (picks.length < count) picks.push(p); });
    return picks;
  }

  // Still working toward free shipping: suggestions sit above the bag items.
  // Free shipping unlocked: they move below the items.
  function place(unlocked) {
    var loop = document.querySelector("#side-cart .cart-loop");
    if (!loop || !loop.parentNode) return;
    if (unlocked) loop.parentNode.insertBefore(nudge, loop.nextSibling);
    else loop.parentNode.insertBefore(nudge, loop);
    nudge.classList.toggle("is-top", !unlocked);
  }

  function hideNudge() { nudge.hidden = true; nudge.innerHTML = ""; }

  function refresh() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var remaining = thresholdCents - cart.total_price;
        var pct = thresholdCents > 0 ? Math.min(100, Math.round(cart.total_price / thresholdCents * 100)) : 100;

        var bar = box.querySelector(".ship-bar");
        if (!bar) {
          bar = document.createElement("span");
          bar.className = "ship-bar";
          bar.innerHTML = '<span class="ship-bar-fill"></span>';
          box.appendChild(bar);
        }
        bar.firstChild.style.width = pct + "%";

        if (remaining > maxGapCents || cart.item_count === 0) return hideNudge();
        var unlocked = remaining <= 0;
        place(unlocked);
        if (unlocked) remaining = 0; // after free shipping: lead with the smallest add-ons

        var inCart = cart.items.map(function (i) { return i.variant_id; });
        return Promise.all([loadPool(hardware), loadPool(collection), loadExtras(), loadPinned(), loadSmallGap()]).then(function (lists) {
          var hwList = lists[0].concat(lists[2]), charmList = lists[1];
          var hwIds = hwList.map(function (p) { return p.id; });
          var hasHardware = inCart.some(function (id) { return hwIds.indexOf(id) !== -1; });
          // Blind box first, then one clip or chain (unless the bag already has one), then charms
          var box1 = pinnedPick(lists[3], remaining, inCart);
          var picks = box1 ? [box1] : [];
          var taken = inCart.concat(picks.map(function (p) { return p.id; }));
          if (!hasHardware) picks = picks.concat(pick(hwList, remaining, taken, hardwareSlots));
          taken = inCart.concat(picks.map(function (p) { return p.id; }));
          // Logo charm takes the last spot when the order is $5 or less away
          var small = lists[4];
          if (small && remaining <= smallGap.maxCents && small.price >= remaining && taken.indexOf(small.id) === -1 && picks.length < maxItems) {
            picks.push(small);
            taken.push(small.id);
          }
          picks = picks.concat(pick(charmList, remaining, taken, maxItems - picks.length));
          if (!picks.length) return hideNudge();
          var allClose = picks.every(function (p) { return p.price >= remaining; });
          var label = unlocked ? labelOver : (allClose ? labelUnder : labelUnderFew);
          nudge.innerHTML =
            '<span class="nudge-label">' + esc(label) + '</span>' +
            '<div class="nudge-wrap"><button type="button" class="nudge-arrow nudge-prev" aria-label="Previous">&#8249;</button>' +
            '<div class="nudge-row">' +
            picks.map(function (p) {
              return '<div class="nudge-item">' +
                '<a class="nudge-img" href="/products/' + p.handle + '"><img src="' + esc(sized(p.image)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
                '<div class="nudge-info">' +
                '<div class="nudge-name' + (p.note ? ' has-note' : '') + '"><a class="nudge-title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
                (p.note ? '<span class="nudge-note">' + esc(p.note) + '</span>' : '') + '</div>' +
                '<div class="nudge-buy"><span class="nudge-price">' + money(p.price) + '</span>' +
                '<button type="button" class="nudge-add" data-variant-id="' + p.id + '">+ Add</button></div>' +
                '</div></div>';
            }).join("") + '</div><button type="button" class="nudge-arrow nudge-next" aria-label="More">&#8250;</button></div>';
          nudge.hidden = false;
          updateArrows();
        });
      })
      .catch(function () {});
  }

  // cart.js replaces the message (and drops the bar) after every cart change
  new MutationObserver(function () {
    if (!box.querySelector(".ship-bar")) refresh();
  }).observe(box, { childList: true });

  // Swipe row: arrows for mouse users, hidden at either end
  function updateArrows() {
    var row = nudge.querySelector(".nudge-row");
    if (!row) return;
    var prev = nudge.querySelector(".nudge-prev"), next = nudge.querySelector(".nudge-next");
    var max = row.scrollWidth - row.clientWidth - 2;
    if (prev) prev.hidden = row.scrollLeft <= 2;
    if (next) next.hidden = row.scrollLeft >= max;
    if (!row._bound) {
      row._bound = true;
      row.addEventListener("scroll", updateArrows, { passive: true });
    }
  }

  nudge.addEventListener("click", function (e) {
    var arrow = e.target.closest(".nudge-arrow");
    if (arrow) {
      e.preventDefault();
      var row = nudge.querySelector(".nudge-row");
      var step = row.clientWidth * 0.9;
      row.scrollBy({ left: arrow.classList.contains("nudge-prev") ? -step : step, behavior: "smooth" });
      return;
    }
    var btn = e.target.closest(".nudge-add");
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = "Adding…";
    if (typeof addSingleItemToCart === "function") {
      addSingleItemToCart(btn.dataset.variantId); // cart.js: adds, then refreshes the whole drawer
    } else {
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }) })
        .then(function () { location.reload(); });
    }
  });

  refresh();
})();
